import { ReactElement } from 'react'
import {
  DefaultSectionTypography,
  DefaultSectionTypographyProps,
} from 'src/shared/presentation/DefaultSectionTypography'

export const DataGridDefaultSectionTypography = (props: DefaultSectionTypographyProps): ReactElement => {
  return <DefaultSectionTypography component="span" {...props} />
}
